import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { ImgBox } from 'views/rebranded-module/common/components';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import StyledBox from 'views/rebranded-module/information-module/AboutUsViewV2/components/FutureSection/FutureSection.styles';

const FutureSection: React.FC = () => {
  const content = useContent('AboutUsPage');
  const getSizedImage = useAdabtiveMultiSizeImage();

  return (
    <StyledBox>
      <Box className="FSOverlay" />
      <Box className="FSBackgroundImage">
        <ImgBox
          image={{
            src: getSizedImage(content.futureBackgroundImage),
            alt: content.futureBackgroundImage.alt,
          }}
          width="100%"
          height="100%"
          unoptimized
        />
      </Box>
      <Container>
        <Box className="FSContent">
          <Typography
            variant="h3"
            component="h3"
            className="FSHeading"
            textTransform="uppercase">
            {content.futureHeading}
          </Typography>
          <Typography
            variant="body2"
            component="p"
            className="FSParagraph"
            dangerouslySetInnerHTML={{
              __html: content.futureExpansionParagraph,
            }}
          />
        </Box>
      </Container>
    </StyledBox>
  );
};

export { FutureSection };
